import React, { useEffect } from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router';
import GoogleIcon from '@mui/icons-material/Google';

function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/chat');
    }
  }, [user, navigate]);

  const handleGoogleSignIn = async () => {
    try {
      await login();
      // Successful login will be handled by the useEffect above
    } catch (error) {
      console.error('Error during Google sign-in:', error);
      // You might want to show an error message to the user
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Stack spacing={4} alignItems="center">
        <Typography variant="h4" component="h1">
          Faana Advisor
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center">
          Sign in with your Google account to get started
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleGoogleSignIn}
          startIcon={<GoogleIcon />}
          size="large"
          sx={{ py: 1, px: 3 }}
        >
          Sign in with Google
        </Button>
      </Stack>
    </Box>
  );
}

export default LoginPage;